<template>
    <div class="address-item">
        <div class="address-text" :class="{'active':item.id==clickId}"
             @click="selectItem(item.id)">
            <p>收货地址：{{item.provinceName}} {{item.cityName}} {{item.area}} {{item.detail}}</p>
            <p>联络人：{{item.userName}}、{{item.phone}}</p>
        </div>
        <div class="address-btn">
            <app-button size="sm"
                        :color="item.isDefault==1 ? 'golden-solid':'gray-solid'"
                        @click.native="setDefault(item.id)">默认地址
            </app-button>
            <app-button size="sm" color="gray-solid"
                        @click.native="editAddress(item.id)">编辑地址
            </app-button>
            <app-button size="sm" color="gray-solid"
                        @click.native="deleteAddress(item.id)">删除
            </app-button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        props: ['item', 'clickId'],
        components: {},
        computed: {},
        created() {
        },
        activated() {
        },
        mounted() {
        },
        methods: {
            deleteAddress(id) {
                this.$store.dispatch('address/deleteAddress', id);
            },
            setDefault(id) {
                this.$store.dispatch('address/setDefault', id);
            },
            editAddress(id) {
                this.$emit('editAddress', id)
            },
            selectItem(id) {
                this.$emit('selectItem', id)
            },
        }
    }
</script>

<style lang="scss" type="text/scss">
    @import "../../style/page-common";

    .address-item {
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;

        .address-text {
            min-width: 550px;
            font-size: 13px;
            line-height: 18px;
            padding: 12px 0px;
            position: relative;
            color: #1F1F1FFF;

            p {
                margin-bottom: 5px;
            }
        }

        .address-btn {
            padding-top: 12px;

            button {
                margin-left: 10px;
            }
        }
    }
</style>